__turbopack_context__.v({
  "accent": "uEeb8W_accent",
  "accentCyan": "uEeb8W_accentCyan",
  "accentGreen": "uEeb8W_accentGreen",
  "badge": "uEeb8W_badge",
  "badgeBlue": "uEeb8W_badgeBlue",
  "badgeCyan": "uEeb8W_badgeCyan",
  "badgeGreen": "uEeb8W_badgeGreen",
  "border": "uEeb8W_border",
  "cols3": "uEeb8W_cols3",
  "cols4": "uEeb8W_cols4",
  "groupPrimary": "uEeb8W_groupPrimary",
  "iconTile": "uEeb8W_iconTile",
  "infoCard": "uEeb8W_infoCard",
  "infoCardGroup": "uEeb8W_infoCardGroup",
  "primary": "uEeb8W_primary",
  "small": "uEeb8W_small",
  "title": "uEeb8W_title",
});
